import React, { useEffect, useState } from 'react';
import { AboutExperience } from '../components/website/AboutExperience';
import { DraftBanner } from '../components/website/DraftBanner';
import { getDraftWebsiteContent, getPublishedWebsiteContent, getRequestedStage, websiteDraftStorageKey, websiteDraftUpdatedEvent, websiteStorageKey, websiteUpdatedEvent, type WebsiteContent } from '../data/website';
import { useWebsiteSeo } from '../hooks/useWebsiteSeo';
import { buildAboutStructuredData } from '../data/aboutSchema';
export function AboutPage() {
  const isDraft = getRequestedStage() === 'draft';
  const read = () => isDraft ? getDraftWebsiteContent() : getPublishedWebsiteContent();
  const [content, setContent] = useState<WebsiteContent>(read);
  useWebsiteSeo(content, {
    noIndex: isDraft,
    title: content.aboutSeoTitle,
    description: content.aboutSeoDescription,
    shareTitle: content.aboutShareTitle,
    shareDescription: content.aboutShareDescription,
    shareImageUrl: content.aboutShareImageUrl || content.aboutHeroImageUrl,
    canonicalPath: '/about',
    ogType: 'profile',
    structuredData: buildAboutStructuredData(content)
  });
  useEffect(() => {
    const refresh = () => setContent(read());
    const sync = (event: Event) => setContent((event as CustomEvent<WebsiteContent>).detail ?? read());
    const watchedKey = isDraft ? websiteDraftStorageKey : websiteStorageKey;
    const watchedEvent = isDraft ? websiteDraftUpdatedEvent : websiteUpdatedEvent;
    const syncStorage = (event: StorageEvent) => {
      if (event.key === watchedKey) refresh();
    };
    window.addEventListener(watchedEvent, sync);
    window.addEventListener('storage', syncStorage);
    window.addEventListener('focus', refresh);
    return () => {
      window.removeEventListener(watchedEvent, sync);
      window.removeEventListener('storage', syncStorage);
      window.removeEventListener('focus', refresh);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDraft]);
  return <>
      {isDraft && <DraftBanner data-id="element-1407" data-mp="3w3ovhqeepgpm" />}
      <AboutExperience content={content} data-id="element-1408" data-mp="3r6onvb1ws5we" />
    </>;
}